import HeroCarousel from '@/pages/home/components/HeroCarousel';
import LatestNews from '@/pages/home/components/LatestNews';
import HomeSidebar from '@/pages/home/components/HomeSidebar';
import CharacterSpotlight from '@/pages/home/components/CharacterSpotlight';
import VersionBanner from '@/pages/home/components/VersionBanner';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function Home() {
  usePageMeta({
    title: '原神游戏资讯平台-最新攻略与玩法讲解',
    description:
      '原神提供全面的游戏资讯、角色攻略、版本更新和玩法解析，帮助玩家深入了解游戏内容，提升游戏体验。覆盖原神全系列内容，满足玩家攻略查询需求。',
    keywords: '原神,原神攻略,原神资讯,原神角色,原神玩法,原神版本更新',
  });

  return (
    <div className="w-full">
      <HeroCarousel />

      <div className="container-page py-10 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3 lg:gap-10">
          <div className="lg:col-span-2">
            <LatestNews />
            <CharacterSpotlight />
          </div>
          <div className="lg:col-span-1">
            <div className="lg:sticky lg:top-[88px]">
              <HomeSidebar />
            </div>
          </div>
        </div>

        <VersionBanner />
      </div>
    </div>
  );
}